import client from "./client";

export const fetchDids = async (
  user,
  deviceid,
  page,
  pageSize,
  search,
  filter
) => {
  return client.get(`/user/${user}/voip/${deviceid}/did`);
};
